/**
 * Whether a saved-list API payload represents a recipe (tags or list_metadata).
 */
export function isSavedListRecipe(list) {
  if (!list || typeof list !== 'object') return false
  const tags = Array.isArray(list.tags) ? list.tags : []
  if (tags.some((t) => String(t).toLowerCase() === 'recipe')) return true
  const meta =
    list.list_metadata && typeof list.list_metadata === 'object' ? list.list_metadata : {}
  const v = meta.is_recipe
  if (v === true || v === 'true' || v === 1 || v === '1') return true

  // Keep frontend behavior aligned with backend recipe detection fallback.
  // Some legacy URL-imported recipes were missing explicit recipe tag/flag.
  if (typeof meta.source_url === 'string' && meta.source_url.trim()) return true
  if (typeof meta.recipe_name === 'string' && meta.recipe_name.trim()) return true
  if (typeof list.description === 'string' && list.description.trim().toLowerCase().startsWith('recipe:')) return true

  return false
}
